import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { to:'/',           icon:'📊', label:'Dashboard'    },
  { to:'/transactions',icon:'📈',label:'Transactions' },
  { to:'/budgets',    icon:'🎯', label:'Budgets'      },
  { to:'/recurring',  icon:'🔁', label:'Recurring'    },
  { to:'/goals',      icon:'🏦', label:'Savings Goals'},
  { to:'/reports',    icon:'📋', label:'Reports'      },
  { to:'/settings',   icon:'⚙️', label:'Settings'     },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#F0F4F8', fontFamily:'Arial,sans-serif' }}>
      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 60 : 220,
        background:'linear-gradient(180deg,#1E2A38 0%,#2E4057 100%)',
        color:'#fff', display:'flex', flexDirection:'column',
        transition:'width 0.2s', flexShrink:0, position:'sticky', top:0, height:'100vh'
      }}>
        {/* Logo */}
        <div style={{
          padding: collapsed ? '20px 0' : '20px 20px',
          borderBottom:'1px solid rgba(255,255,255,0.1)',
          display:'flex', alignItems:'center', justifyContent: collapsed?'center':'space-between'
        }}>
          {!collapsed && (
            <div>
              <div style={{ fontSize:13, fontWeight:700, letterSpacing:1 }}>💰 BUDGET</div>
              <div style={{ fontSize:10, color:'#F5A623', marginTop:2 }}>AA Experts</div>
            </div>
          )}
          <button onClick={()=>setCollapsed(!collapsed)}
            style={{ background:'none', border:'none', color:'#fff', cursor:'pointer', fontSize:16, padding:4 }}>
            {collapsed ? '→' : '←'}
          </button>
        </div>

        {/* Nav */}
        <nav style={{ flex:1, paddingTop:12 }}>
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to==='/'} style={({ isActive }) => ({
              display:'flex', alignItems:'center', gap:12,
              padding: collapsed ? '12px 0' : '12px 20px',
              justifyContent: collapsed ? 'center' : 'flex-start',
              textDecoration:'none', fontSize:13, fontWeight:500,
              color: isActive ? '#F5A623' : 'rgba(255,255,255,0.8)',
              background: isActive ? 'rgba(245,166,35,0.1)' : 'transparent',
              borderLeft: isActive ? '3px solid #F5A623' : '3px solid transparent',
              transition:'all 0.15s'
            })}>
              <span style={{ fontSize:16 }}>{n.icon}</span>
              {!collapsed && n.label}
            </NavLink>
          ))}
        </nav>

        {/* User */}
        <div style={{
          padding: collapsed ? '12px 0' : '12px 20px',
          borderTop:'1px solid rgba(255,255,255,0.1)',
          display:'flex', alignItems:'center', gap:10,
          justifyContent: collapsed ? 'center' : 'flex-start'
        }}>
          <div style={{
            width:32, height:32, borderRadius:'50%', background:'#F5A623',
            display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:14, fontWeight:700, color:'#1E2A38', flexShrink:0
          }}>
            {user?.username?.[0]?.toUpperCase()}
          </div>
          {!collapsed && (
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:12, fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                {user?.username}
              </div>
              <button onClick={handleLogout}
                style={{ background:'none', border:'none', color:'#F5A623', cursor:'pointer',
                         fontSize:11, padding:0, marginTop:2 }}>
                Sign out
              </button>
            </div>
          )}
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex:1, overflow:'auto', padding:'24px' }}>
        {children}
      </main>
    </div>
  );
}
